import HMLogo from '../assets/img/clientLogos/H&M - png 0.svg'
import googleLogo from '../assets/img/clientLogos/Google svg.svg'
import appleLogo from '../assets/img/clientLogos/Apple - png 0.svg'
import pinterestLogo from '../assets/img/clientLogos/Pinterest - png.svg'
import stripeLogo from '../assets/img/clientLogos/Frame 128.svg'
import adobeLogo from '../assets/img/clientLogos/Adobe - png 0.svg'
import airbnbLogo from '../assets/img/clientLogos/Airbnb - png 0.svg'
const clientLogos = [
    {
        index: 0,
        clientLogo: HMLogo
    },
    {
        index: 1,
        clientLogo: googleLogo
    },
    {
        index: 2,
        clientLogo: appleLogo
    },
    {
        index: 3,
        clientLogo: pinterestLogo
    },
    {
        index: 4,
        clientLogo: stripeLogo
    },
    {
        index: 5,
        clientLogo: adobeLogo
    },
    {
        index: 6,
        clientLogo: airbnbLogo
    }
]

export default clientLogos